import { SIGN_UP_TOKEN_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { signUpToken } from 'root/src/client/logic/auth/thunks/signUpToken'

export default {
	[SIGN_UP_TOKEN_FORM_MODULE_ID]: [
		{
			action: signUpToken,
		},
	],
}
